import type { CustomField } from 'common/api/endpoints/companies';
import type { ThirdPartyCompanyDefaultField } from 'common/thirdPartyCompanies/constants';

export type Field = {
  name: string;
  type: CustomField['fieldType'];
  integrations: string[];
};

export type FieldMapping = Record<ThirdPartyCompanyDefaultField, string | null>;

export const fieldIsSalesforce = (fieldName: string | null, fields: Field[]) => {
  if (!fieldName) {
    return false;
  }

  const field = fields.find((field) => field.name === fieldName);
  const isSalesforce = field?.integrations.includes('salesforce');
  return isSalesforce;
};
